import { styled } from '@creditas-ui/system';
import { Flex } from '@creditas-ui/layout';
import { media, prop } from '@creditas-ui/utilities';

const DrawerFooterElement = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  background-color: ${prop('theme.colors.neutral.0')};
  padding: ${prop('theme.spacingX.5xl')};
  min-height: 100px;

  ${media.up('4xl')} {
    padding: ${prop('theme.spacingX.12xl')};
    min-height: 156px;
  }
`;

export { DrawerFooterElement };
